/**
 * TokenStorage
 * Manages in-memory storage of the access token
 *
 * Security note: Access tokens are stored in memory (not localStorage)
 * to prevent XSS attacks. The token is lost on page reload, which is
 * acceptable since we use a refresh token cookie to restore the session.
 */
export class TokenStorage {
  private accessToken: string | null = null;

  /**
   * Store the access token in memory
   */
  public setAccessToken(token: string): void {
    this.accessToken = token;
  }

  /**
   * Get the current access token
   */
  public getAccessToken(): string | null {
    return this.accessToken;
  }

  /**
   * Clear the access token from memory
   */
  public clearAccessToken(): void {
    this.accessToken = null;
  }

  /**
   * Check if an access token exists
   */
  public hasAccessToken(): boolean {
    return this.accessToken !== null && this.accessToken.length > 0;
  }
}

// Export a singleton instance
export const tokenStorage = new TokenStorage();
